import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const cartPopup = css`
  width: 100%;
  padding: 0.5rem;

  @media only screen and (min-width: ${dimensions.tabletMax}) {
    width: 19rem;
  }
  @media only screen and (max-width: ${dimensions.tabletMax}) {
    padding: 0.125rem 0.5rem 0.5rem;
  }
`;
